import Benchwalk1 from "./beachwalk (1).webp";
import Benchwalk2 from "./beachwalk (2).webp";
import Benchwalk3 from "./beachwalk (3).webp";
import Benchwalk4 from "./beachwalk (4).webp";
import Benchwalk5 from "./beachwalk (5).webp";
import Benchwalk6 from "./beachwalk (6).webp";
import Benchwalk7 from "./beachwalk (7).webp";
import Benchwalk8 from "./beachwalk (8).webp";
import Benchwalk9 from "./beachwalk (9).webp";
import Benchwalk10 from "./beachwalk (10).webp";
import Benchwalk11 from "./beachwalk (11).webp";
import Benchwalk12 from "./beachwalk (12).webp";
import Benchwalk13 from "./beachwalk (13).webp";
import Benchwalk14 from "./beachwalk (14).webp";

const benchwalk = [
  Benchwalk1,
  Benchwalk2,
  Benchwalk3,
  Benchwalk4,
  Benchwalk5,
  Benchwalk6,
  Benchwalk7,
  Benchwalk8,
  Benchwalk9,
  Benchwalk10,
  Benchwalk11,
  Benchwalk12,
  Benchwalk13,
  Benchwalk14,
];

export default benchwalk;
